export type Precept = {
  kanji: string
  romaji: string
  title: string
  text: string
}

export const DOJO_KUN: Precept[] = [
  { kanji: '義', romaji: 'Gi', title: 'La Droiture', text: 'Agir avec justice, sur le tatami comme en dehors du dojo.' },
  { kanji: '勇', romaji: 'Yū', title: 'Le Courage', text: 'Affronter la difficulté, l’adversaire et surtout soi-même.' },
  { kanji: '仁', romaji: 'Jin', title: 'La Bienveillance', text: 'Protéger le plus faible, accompagner le débutant.' },
  { kanji: '礼', romaji: 'Rei', title: 'Le Respect', text: 'La politesse ouvre et referme chaque instant de pratique.' },
  { kanji: '誠', romaji: 'Makoto', title: 'La Sincérité', text: 'Un coup juste est un coup vrai, sans ornement ni tricherie.' },
  { kanji: '名誉', romaji: 'Meiyo', title: 'L’Honneur', text: 'La réputation se construit par les actes, jamais par les mots.' },
  { kanji: '忠義', romaji: 'Chūgi', title: 'La Loyauté', text: 'Le dévouement envers le club, les partenaires et les enseignants.' },
]

export const HISTORY = [
  {
    year: '2008',
    title: 'Fondation du club',
    text: 'Ouverture des portes du dojo à Castelnau d’Estrétefonds avec la volonté de partager la passion du karaté traditionnel auprès des familles du village.',
  },
  {
    year: '2014',
    title: 'Développement & esprit de famille',
    text: 'Agrandissement des sections, des enfants aux adultes, et création d’une véritable communauté locale où parents et pratiquants font vivre l’association.',
  },
  {
    year: '2019',
    title: 'Vers le haut niveau',
    text: 'Affirmation du club en compétition, de la scène régionale aux tatamis internationaux, tout en conservant une section loisir accessible à tous.',
  },
  {
    year: '2026',
    title: 'Une nouvelle identité',
    text: 'Le club dévoile son nouveau logo à la fin de la saison 2025-2026 et engage la création de son site internet pour mettre en visibilité ses activités.',
  },
]

export const IDENTITY_SYMBOLS = [
  {
    kanji: '角',
    title: 'Les cornes de cerf',
    text: 'Sur le kabuto, elles symbolisent la noblesse, la dignité et la force de caractère. Elles rappellent que la véritable puissance ne se mesure pas à la domination des autres, mais à la maîtrise de soi.',
  },
  {
    kanji: '刀',
    title: 'Le katana',
    text: 'Symbole du guerrier japonais, il représente la discipline, la précision et la quête permanente de progression. Il illustre le travail quotidien nécessaire pour avancer, dans la pratique comme dans la vie.',
  },
  {
    kanji: '赤',
    title: 'Le rouge & l’or',
    text: 'Le rouge évoque la détermination et l’engagement. L’or représente l’excellence, le respect des traditions et la réussite obtenue par l’effort.',
  },
]

export type Person = {
  name: string
  role: string
  grade?: string
  details: string[]
  photo?: string
}

export const TEACHERS: Person[] = [
  {
    name: 'Giovanny LAURET',
    role: 'Enseignant — Responsable technique',
    grade: '4ᵉ Dan Karaté Shotokan',
    details: [
      'Diplôme d’État de la Jeunesse, de l’Éducation Populaire et du Sport (DEJEPS)',
      'Diplôme d’Instructeur Fédéral FFKaraté',
      'Juge et arbitre régional Kata',
      'Responsable de la section compétition',
    ],
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8418dd6f-d10f-4877-9e26-df9835f1b4f9.jpg',
  },
  {
    name: 'Christophe ADONIS',
    role: 'Enseignant — Sections enfants & adultes',
    grade: '3ᵉ Dan Karaté Shotokan',
    details: [
      'Certificat de Qualification Professionnelle (CQP) Moniteur d’Arts Martiaux',
      'Diplôme d’Animateur Fédéral FFKaraté',
      'Préparateur mental diplômé',
      'Formation Karaté Santé & Para-karaté',
    ],
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9a350890-7da5-4494-9af9-37d56a4bac19.jpg',
  },
]

export const BOARD: Person[] = [
  { name: 'Sophie MARTIN', role: 'Présidente', details: [] },
  { name: 'Karim BENALI', role: 'Vice-président', details: [] },
  { name: 'Élodie ROUX', role: 'Trésorière', details: [] },
  { name: 'Nicolas FABRE', role: 'Secrétaire', details: [] },
  { name: 'Laura CAZES', role: 'Chargée de communication', details: [] },
  { name: 'Thomas VIDAL', role: 'Référent compétition', details: [] },
]

export const PRESS = [
  {
    source: 'La Dépêche du Midi',
    date: '14 juin 2026',
    title: 'Le Zanshin Karaté Club dévoile sa nouvelle identité visuelle',
    excerpt:
      'Le club castelnaudais a présenté son nouveau logo lors de la fête de fin de saison, devant les familles réunies au complexe sportif Fondada.',
  },
  {
    source: 'La Dépêche du Midi',
    date: '3 mars 2026',
    title: 'Deux podiums pour les jeunes karatékas au championnat départemental',
    excerpt:
      'Les compétiteurs du Zanshin se sont illustrés à Toulouse avec une médaille d’or en kata et une médaille de bronze en kumite.',
  },
  {
    source: 'Bulletin municipal',
    date: 'Septembre 2025',
    title: 'Un dojo ouvert à tous dès 7 ans',
    excerpt:
      'Reportage sur la rentrée sportive et les cours d’essai gratuits proposés par le club durant tout le mois de septembre.',
  },
]
